import script from "./ProcessHistory.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProcessHistory.vue?vue&type=script&lang=ts&setup=true"

import "./ProcessHistory.vue?vue&type=style&index=0&id=7cf0d183&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cf0d183"]])

export default __exports__